
import React from 'react'

import useTranslation from '../../Hooks/UseTranslation'

import './SplashPage.scss'

const SplashPage = () => {

  const { t } = useTranslation()

  return (
    <div className="pl4-splash" role="status" aria-live="polite">
      <div className="pl4-splash__content">
        <div className="pl4-splash__brand">
          <img className="pl4-splash__brand-icon" src="/svg-icons/logo-icon.svg" alt="" aria-hidden="true" />
          <img className="pl4-splash__brand-logo" src="/svg-icons/logo.svg" alt="PL4NNER" />
        </div>

        <div className="pl4-splash__progress" aria-hidden="true">
          <span />
        </div>

        <p>{t('SPLASH:Loading')}</p>
      </div>
    </div>
  )
}

export default SplashPage
